exports.formatDate = (value,langCode) => {
  const dateFormatOptions = {
    month: 'short', day: 'numeric', year:'numeric'
   } 
  return new Intl.DateTimeFormat(langCode?langCode:'en', dateFormatOptions).format(new Date(value));
}
